import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_MODIFICAR_DATA,
    AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS } from '../../../../actions/actionTypes';

const ESTAT_INICIAL_DATA_INTRODUCCIO_AVIS = null;

const data = (state = ESTAT_INICIAL_DATA_INTRODUCCIO_AVIS, action) => {

    switch (action.type) {
        case AVIS_INTRODUCCIO_MODIFICAR_DATA:
            return action.dataAvis;

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL_DATA_INTRODUCCIO_AVIS;

        case AVIS_OMPLIR_FORMULARI_AMB_UN_AVIS:
            return action.avis.data;

        default:
            return state;
    }
};

export default data;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/dades/data.js